import { getCampaignUrl, getCampaignUrlTargetParams } from './helpers';

export const GET_TOPBANNER_SUCCESS = 'topbanner/GET_TOPBANNER_SUCCESS';
export const GET_TOPBANNER_FAILURE = 'topbanner/GET_TOPBANNER_FAILURE';

const onSuccess = ({ content }) => {
  const campaign = content[0];

  return {
    type: GET_TOPBANNER_SUCCESS,
    payload: { campaign },
  };
};
const onFailure = () => ({
  type: GET_TOPBANNER_FAILURE,
});

export const getTopbannerAction = (
  baseUrl,
  platform,
  market,
  pageName,
  ancestors,
  userId,
  isNewUser,
) => {
  const targetParams = getCampaignUrlTargetParams(
    pageName,
    ancestors,
    userId,
    isNewUser,
  );
  const apiEndpoint = getCampaignUrl(baseUrl, platform, market, targetParams);

  if (!apiEndpoint) {
    return {};
  }

  return {
    payload: {
      url: apiEndpoint,
      method: 'GET',
      onSuccess,
      onFailure,
      timeout: Number.parseInt(process.env.TOPBANNER_TIMEOUT, 10) || 2000,
    },
  };
};
